import { RotateCcwIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { InfoTooltip } from '@/components/atoms/InfoTooltip/InfoTooltip';
import { Button } from '@/components/ui/button';

import { resetConversation } from '../../redux/actions';

export const ResetConversationButton = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <InfoTooltip content={t('try_it.reset_conversation')} side="top">
      <Button
        variant="ghost-neutral"
        size="icon-sm"
        onClick={() => dispatch(resetConversation())}
        aria-label={t('try_it.reset')}
      >
        <RotateCcwIcon size={16} className="text-foreground-muted" />
      </Button>
    </InfoTooltip>
  );
};
